export default __webpack_public_path__ + "sounds/028edfc37caafa1522a368224dc29f06.mp3";